import { render, staticRenderFns } from "./BookDownloadUrlConfig.vue?vue&type=template&id=2b74a7db&scoped=true"
import script from "./BookDownloadUrlConfig.vue?vue&type=script&lang=js"
export * from "./BookDownloadUrlConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74a7db",
  null
  
)

export default component.exports